import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { formatNumberAsString } from '~/core/application/workflow/utils/transformFuncs';
import { WorkflowStepFormFieldDatePattern } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const DateMonthFullYearFieldToBlock: FieldToBlock<
  'date_month_full_year',
  WorkflowStepFormFieldDatePattern
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'date-pattern',
  componentProps: {
    datePattern: 'MM/YYYY',
    size: 'sm',
  },
});

type DateMonthFullYearFieldValueProps = FieldValueProps<'date_month_full_year'>;

export const DateMonthFullYearFieldValue: FC<
  DateMonthFullYearFieldValueProps
> = ({ field }) => {
  const value = formatNumberAsString(field.value ?? 0);

  return <Text>{value}</Text>;
};
